module.exports = __webpack_public_path__ + "media/images/img-traveler-beaa33764e741bf1c3a55d221dbb6c87.svg";